import { render } from "./city-create.vue?vue&type=template&id=4dc2dcb2&scoped=true"
import script from "./city-create.vue?vue&type=script&lang=js"
export * from "./city-create.vue?vue&type=script&lang=js"

import "./city-create.vue?vue&type=style&index=0&id=4dc2dcb2&scoped=true&lang=css"
import "./city-create.vue?vue&type=style&index=1&id=4dc2dcb2&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc2dcb2"]])

export default __exports__